var React = require('react');

function RelaxedIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#fff"},[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.598 7.415A10.95 10.95 0 0 1 12 6c5.568 0 10.17 4.136 10.9 9.504.11.82-.572 1.496-1.4 1.496s-1.487-.677-1.623-1.494C19.165 11.246 15.462 8 11 8a8.984 8.984 0 0 0-3.06.533L6.598 7.415zm-2.37 1.801A10.964 10.964 0 0 0 1.01 16.5c-.012.276.213.5.49.5a.522.522 0 0 0 .513-.5 8.981 8.981 0 0 1 3.174-6.372l-.96-.912z","key":0}),React.createElement("path",{"d":"m2 7 8.593 10.502a1.357 1.357 0 1 0 1.91-1.91L2 7z","key":1})]));
}

RelaxedIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = RelaxedIcon;

RelaxedIcon.default = RelaxedIcon;
